import { Geocoder } from "./Geocoder";

export class CustomPoint {
    center = [];
    geometry = {
        coordinates: [],
        type: "",
    };
    properties = {
        id: "",
        symbol: "",
    };
    place_name = "";

    setCoordinates(coords) {
        this.center = coords;
        this.geometry = {};
        this.geometry.type = "Point";
        this.geometry.coordinates = coords;

        return this;
    }
    setId(id) {
        this.properties.id = id;
        this.properties["symbol"] = "pin" + id;
        return this;
    }
    setName(name) {
        this.place_name = name;
        return this;
    }

    build() {
        return this;
    }
};

export class CustomPointNoCoords extends CustomPoint {
    geocoderHBD = new Geocoder();
    build() {
        super.build();

        this.geocoderHBD.setAsync(false);
        this.geocoderHBD.query({
            query: this.place_name,
            center: ([47.6964719, 13.3457347]).toString()
        }, (data) => {
            this.center = data.results.features[0].geometry.coordinates;
            this.geometry = {};
            this.geometry.type = 'Point';
            this.geometry.coordinates = data.results.features[0].geometry.coordinates;
        });

        return this;
    }
}